import Vue from "vue";
import Vuex from "vuex";
import ttest from "./modules/ttest";
import auth from "./modules/auth";
import journal from "./modules/journal";
import viewingDiscipline from "./modules/viewingDiscipline";
import messages from "./modules/messages";
import tresult from "./modules/tresult";
import handbook from "./modules/handbook";
import schedule from "./modules/schedule"
import docs from "./modules/docs";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    enterPoint: "",
    userData: null,
    loadingIcon: false,
    mobileMode: false,
    widthWindow: window.innerWidth,
    dataPage: null,
    currentRoute: "",
    pageTab: [],
    modalData: null,
  },
  mutations: {
    setEnterPoint(state, value) {
      state.enterPoint = value;
    },
    setUserData(state, value) {
      state.userData = value;
    },
    setModalData(state, value) {
      return (state.modalData = value);
    },
    setPageTab(state, value) {
      return (state.pageTab = value);
    },
    setCurrenttRoute(state, value) {
      return (state.currentRoute = value);
    },
    setWidthWindow(state, value) {
      return (state.widthWindow = value);
    },
    updateDataPage(state, value) {
      state.dataPage = value;
    },
    setMobileMode(state, value) {
      state.mobileMode = value;
    },
    logoutUser(state) {
      state.user.loggedIn = false;
    },
    setLoadingIcon(state, value) {
      state.loadingIcon = value;
    },
  },
  actions: {
    async fetchDataForPage({ commit, getters, dispatch, state }, path = "") {
     try {
      let data = null;
      let newPath = ("/api" + path).toLowerCase();
      await axios.get(newPath).then(response => {
        commit("updateDataPage", response.data);
        data = response;
      });
      return data;
     } catch(error) {
      console.warn('Failed fetch [store/fetchDataForPage]', error);
     }
    },
    async updateDataPage({ commit, getters, dispatch, state }, { path, data }) {
      let newPath = ("/api" + path).toLowerCase();
      await axios
        .patch(newPath, data)
        .then(res => {
          return true;
        })
        .catch(() => {
          return false;
        });
    },
  },
  modules: {
    ttest,
    auth,
    journal,
    viewingDiscipline,
    messages,
    tresult,
    handbook,
    schedule,
    docs
  },
  getters: {
    getUser(state) {
      return state.auth.user;
    },
    getAuthenticated(state) {
      return state.auth.authenticated;
    },
    getBaseUrl(state) {
      return state.baseUrl;
    },
    getDataForPage(state) {
      return state.dataPage;
    },
    loadingIconStatus(state) {
      return state.loadingIcon;
    },
    mobileMode(state) {
      return state.mobileMode;
    },
    auth(state) {
      return state.user;
    },
  },
});
